import { Directive } from '@angular/core';

/**
 * Direktive, die Icon-Button verkleinert
 */
@Directive({
    selector: '[ibtnSmall]',
    host: { class: 'ibtn-small' }
})
export class IconButtonSmallDirective {
}
